import './style.scss'
import React, { useEffect, useState } from 'react'
import { Modal, Button, Text, tokens } from 'src/componentv2'
import { FAQ_CATEGORIES } from 'src/componentv2/Curated/FAQCard/categories'

export interface FAQFormValue {
    category: string
    question: string
    answer: string
}

export interface FAQModalProps {
    open: boolean
    onClose: () => void
    onSave: (value: FAQFormValue) => void
    initialValue?: FAQFormValue
    mode?: 'add' | 'edit'
    saving?: boolean
}

const EMPTY: FAQFormValue = { category: FAQ_CATEGORIES[0], question: '', answer: '' }

export const FAQModal: React.FC<FAQModalProps> = ({
                                                      open, onClose, onSave, initialValue, mode = 'add', saving = false,
                                                  }) => {
    const [form, setForm] = useState<FAQFormValue>(initialValue ?? EMPTY)

    useEffect(() => {
        if (open) setForm(initialValue ?? EMPTY)
    }, [open, initialValue])

    const isValid = form.question.trim().length > 0 && form.answer.trim().length > 0

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={mode === 'edit' ? 'Edit FAQ' : 'Add New FAQ'}
            maxWidth="52rem"
        >
            <Text fontSize="1.4" fontWeight="600" color={tokens.textDark}>
                Category
            </Text>
            <select
                className="faq-modal__select"
                value={form.category}
                onChange={(e) => setForm((f) => ({ ...f, category: e.target.value }))}
            >
                {FAQ_CATEGORIES.map((cat) => (
                    <option key={cat} value={cat}>{cat}</option>
                ))}
            </select>

            <Text topMargin="1.6" fontSize="1.4" fontWeight="600" color={tokens.textDark}>
                Frequently Asked Question
            </Text>
            <textarea
                className="faq-modal__textarea"
                placeholder="Enter Answer title"
                value={form.question}
                onChange={(e) => setForm((f) => ({ ...f, question: e.target.value }))}
            />

            <Text topMargin="1.6" fontSize="1.4" fontWeight="600" color={tokens.textDark}>
                Answer
            </Text>
            <textarea
                className="faq-modal__textarea faq-modal__textarea--tall"
                placeholder="Enter Answer Text"
                value={form.answer}
                onChange={(e) => setForm((f) => ({ ...f, answer: e.target.value }))}
            />

            <div className="faq-modal__footer">
                <Button disabled={!isValid || saving} onClick={() => onSave(form)}>
                    {saving ? 'Saving...' : 'Save FAQs'}
                </Button>
            </div>
        </Modal>
    )
}

export default FAQModal